import styled from 'styled-components';
import color from 'tinycolor2';

export const Wrapper = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;

  input[type="radio"] {
    opacity: 0;
    position: absolute;
    z-index: -1;
  }

  input[type="radio"]:focus + span {
    box-shadow:
      inset 0 0 0 1px ${(props) => props.theme['color.primary']},
      0 0 0 4px ${(props) => color(props.theme['color.primary']).setAlpha(0.3).toString()};
  }

  input[type="radio"]:checked + span {
    box-shadow: inset 0 0 0 20px ${(props) => props.theme['color.primary']};
  }

  input[type="radio"]:checked:focus + span {
    box-shadow:
      inset 0 0 0 20px ${(props) => props.theme['color.primary']},
      0 0 0 4px ${(props) => color(props.theme['color.primary']).setAlpha(0.3).toString()};
  }

  input[type="radio"] + span::after {
    transform: rotate(45deg) scale(0.4);
    opacity: 0;
  }

  input[type="radio"]:checked + span::after {
    transform: rotate(45deg) scale(1);
    opacity: 1;
  }

  &:hover {
    input[type="radio"] + span {
      background: rgba(0,0,0,0.06);
    }
  }
`;

export const StyledRadioButton = styled.span`
  display: flex;
  height: 20px;
  width: 20px;
  margin-left: 1px;
  margin-right: 13px;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 0 0 2px #d9d9de;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:after {
    content: "";
    height: 8px;
    width: 8px;
    background-color: #FFFFFF;
    border-radius: 50%;
    display: inline-block;
  }
`;

export const Label = styled.span`
  font: inherit;
  color: ${(props) => props.theme['color.text.body']};
`;

export const RadioButtonGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 16px;
  color: ${(props) => props.theme['color.text.body']};
  font-size: 14px;
  line-height: 18px;
`;
